import gql from 'graphql-tag';

export default gql`
  query filterCategoriesRelatedToBrand($filter: FilterCategoriesRelatedToBrandInput, $pagination: Pagination) {
    filterCategoriesRelatedToBrand(filter: $filter, pagination: $pagination) {
      totalResults
      totalPage
      data {
        id
        slug
        name
        activated
      }
    }
  }
`;
